import(/* webpackMode: "eager" */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/app/faqs/page.jsx");
